import { render, staticRenderFns } from "./StyleBlock.vue?vue&type=template&id=22d042ee&"
import script from "./StyleBlock.vue?vue&type=script&lang=js&"
export * from "./StyleBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports